module.exports = __webpack_public_path__ + "static/img/imgNR.bb5695c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newsCenteru/imgNR.png
// module id = Fzay
// module chunks = 1